import React from 'react'
import { Box, Flex } from '@radix-ui/themes'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { BullsEyeGameGraphSkeleton } from './bulls-eye-game-graph-skeleton'
import { BullsEyeGamePoolSkeleton } from './bulls-eye-game-pool-info-skeleton'
import styles from './bulls-eye-game-skeleton.module.scss'

/** Mirrors the redesigned grid: left column, header + chart + lower row, bottom bar, table */
export const BullsEyeGameSkeleton: React.FC = () => {
  return (
    <div className={styles.page}>
      <Flex
        direction={'column'}
        gap={'4'}
        className={styles.left}
      >
        <BullsEyeGamePoolSkeleton />
      </Flex>

      <Flex
        direction={'column'}
        gap={'4'}
        className={styles.right}
      >
        <Box className={styles.panel}>
          <Skeleton
            height={'7rem'}
            borderRadius={'1.5rem'}
          />
        </Box>

        <BullsEyeGameGraphSkeleton />

        <div className={styles.lower}>
          <Box className={styles.panel}>
            <Skeleton
              height={'16rem'}
              borderRadius={'1.5rem'}
            />
          </Box>

          <Box className={styles.panel}>
            <Skeleton
              height={'16rem'}
              borderRadius={'1.5rem'}
            />
          </Box>
        </div>
      </Flex>

      <Box className={styles.bottom}>
        <Skeleton
          height={'6rem'}
          borderRadius={'999px'}
        />
      </Box>

      <Box className={styles.table}>
        <Skeleton
          height={'40rem'}
          borderRadius={'2rem'}
        />
      </Box>
    </div>
  )
}
